import { useEffect, useState } from 'react'

interface SectionDataCommon {
  title?: string
  headingTitle?: string
  fontFamily?: string
  defaultCollectionId?: string
  insiderShelf?: Record<string, unknown>
  campaignId?: string
  campaignIdForMobile?: string
  campaingIdForMobile?: string
  campaignIdForTablet?: string
}

interface ApiResponse {
  sections: {
    id: string
    name: string
    data: SectionDataCommon
  }[]
}

export function useCmsSectionData<
  T extends SectionDataCommon = SectionDataCommon
>(
  sectionName: string
): { data: T | null; loading: boolean; error: Error | null } {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const fetchData = async () => {
      setLoading(true)
      try {
        const searchParams = new URLSearchParams(window.location.search)
        let contentType = searchParams.get('contentType')
        let documentId = searchParams.get('documentId')
        let versionId = searchParams.get('versionId')

        if (
          !contentType ||
          !documentId ||
          !versionId ||
          contentType !== 'globalComponents'
        ) {
          contentType = 'globalComponents'
          documentId = 'a32ef0b8-7178-4ff0-8836-d25662b4db28' //id doc global
          versionId = ''
        }

        const res = await fetch('/api/getCmsContent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ contentType, documentId, versionId }),
        })

        if (!res.ok) {
          throw new Error(`Erro ao acessar o conteúdo CMS: ${res.statusText}`)
        }

        const json = (await res.json()) as ApiResponse

        if (!Array.isArray(json.sections)) {
          throw new Error('Resposta da API não contém uma lista de sections.')
        }

        const section = json.sections.find((s) => s.name === sectionName)

        if (!section) {
          throw new Error(`Seção "${sectionName}" não encontrada.`)
        }

        if (!section.data) {
          throw new Error(`Seção "${sectionName}" encontrada, mas sem dados.`)
        }

        setData(section.data as T)
      } catch (err: any) {
        console.error('[useCmsSectionData] Erro capturado:', err.message)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [sectionName])

  return { data, loading, error }
}
